define('plugin/gallery/view/GalleryIndexView',['require','lib/view/BaseCompositeView','plugin/gallery/view/GalleryItemView','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var GalleryItemView = require('plugin/gallery/view/GalleryItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Gallery composite view (images container)
     *
     * @class GalleryIndexView
     */
    return Parent.extend({

        template: '#gallery_list_view',
        childView: GalleryItemView,
        childViewContainer: '#sb_gallery_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        collectionEvents: {
            sync: 'render'
        },

        _pageId: 'gallery',

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'gallery'
            });
        }

    });

});
